import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'amGender',
    standalone: false
})
export class AmGenderPipe implements PipeTransform {

  transform(gender: string): string {
    switch (gender) {
      case 'MALE':
        return 'paxForms.passport.male';
      case 'FEMALE':
        return 'paxForms.passport.female';
      case 'UNKNOWN':
        return 'documents.unknowngen';
      default:
        return 'documents.unknowngen';
    }
  }

}
